/**
 * Storefront Flow types for multi-step subscription signup wizards
 *
 * Core types are imported from @doughdog/types package.
 * Local types are defined here for admin-specific operations.
 */

import type {
	StorefrontFlow,
	StorefrontFlowBlueprintInput,
	StorefrontFlowResponse,
} from '@doughdog/types';
import { StorefrontFlowStatus, StorefrontFlowStepType } from '@doughdog/types';

/**
 * Alias for blueprint reference used in create/update requests
 * @deprecated Use StorefrontFlowBlueprintInput from @doughdog/types
 */
export type StorefrontFlowBlueprintRef = StorefrontFlowBlueprintInput;

/**
 * Populated storefront flow - alias for the public API response type
 */
export type StorefrontFlowPopulated = StorefrontFlowResponse;

/**
 * Create request body for storefront flow
 * @deprecated Use StorefrontFlowInput from @doughdog/types
 */
export type StorefrontFlowCreateRequest = Omit<StorefrontFlow, 'id' | 'createdAt' | 'updatedAt'>;

/**
 * Update request body for storefront flow (all fields optional)
 */
export type StorefrontFlowUpdateRequest = Partial<
	Omit<StorefrontFlow, 'id' | 'createdAt' | 'updatedAt'>
>;

/**
 * Delete response
 */
export interface StorefrontFlowDeleteResponse {
	deleted: boolean;
	id: string;
}

/**
 * List response with pagination
 */
export interface StorefrontFlowListResponse {
	data: StorefrontFlow[];
	hasMore: boolean;
}

/**
 * Step type labels for display
 */
export const STEP_TYPE_LABELS: Record<StorefrontFlowStepType, string> = {
	[StorefrontFlowStepType.ProductType]: 'Product Type Selection',
	[StorefrontFlowStepType.AssignmentOptions]: 'Product Options (Size, Color, etc.)',
	[StorefrontFlowStepType.Product]: 'Product Selection / Add To Cart',
	[StorefrontFlowStepType.Theme]: 'Theme Selection',
};

/**
 * Status labels for display
 */
export const FLOW_STATUS_LABELS: Record<StorefrontFlowStatus, string> = {
	[StorefrontFlowStatus.Draft]: 'Draft',
	[StorefrontFlowStatus.Published]: 'Published',
};
